// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1blbo","block":"block--2fw0x","block-title":"block-title--2f-tM","btn-line":"btn-line--PqvZc","full":"full--wiRIc"};